import { BrokerProductCategory } from '@/services/brokers/types';

export function parseProductCode(productCode: string): BrokerProductCategory {
  switch (productCode) {
    case '180007':
      return 'BUSINESS_INSURANCE';
    case '930015':
      return 'OTHER' as BrokerProductCategory;
    case '930016':
      return 'GROUP_LIFE_INSURANCE';
    case '140001':
    default:
      return 'HOME_INSURANCE';
  }
}
